import { useState } from 'react';
import { motion } from 'framer-motion';

export default function AvailabilityPill() {
  const [expanded, setExpanded] = useState(false);

  const scrollToEstimate = () => {
    const el = document.getElementById('estimate');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <motion.div
      data-testid="availability-pill"
      className="fixed z-[490] right-6 cursor-pointer"
      style={{ bottom: '196px' }}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
      onClick={scrollToEstimate}
      whileHover={{ scale: 1.05 }}
    >
      <div className="flex items-center gap-2 rounded-full px-3 py-1.5 backdrop-blur-2xl" style={{ background: 'rgba(8,10,13,0.85)', border: '1px solid rgba(16,185,129,0.35)' }}>
        <motion.div
          className="w-2 h-2 rounded-full flex-shrink-0"
          style={{ background: '#10B981' }}
          animate={{ scale: [1, 1.4, 1], opacity: [1, 0.6, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        />
        <span className="font-sans font-semibold text-[11px] whitespace-nowrap" style={{ color: 'rgba(255,255,255,0.75)' }}>
          24/7 Available
        </span>
        {expanded && (
          <motion.span
            className="font-sans font-semibold text-[11px] whitespace-nowrap"
            style={{ color: '#E8A020' }}
            initial={{ opacity: 0, width: 0 }}
            animate={{ opacity: 1, width: 'auto' }}
            exit={{ opacity: 0, width: 0 }}
          >
            &middot; Request Estimate Now &rarr;
          </motion.span>
        )}
      </div>
    </motion.div>
  );
}
